import React, { useMemo } from "react";
import ReportDataTable from "./ReportDataTable";

const defaultTotals = {
  subTotal: 0,
  cgst: 0,
  sgst: 0,
  viaCash: 0,
  viaCard: 0,
  viaUpi: 0,
  grandTotal: 0,
};

const formatAmount = (value) => `Rs.${Number(value || 0).toFixed(2)}`;
const formatDate = (value) => (value ? String(value).slice(0, 10) : "--------");

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Order Dates", key: "date", render: (row) => formatDate(row.date || row.orderDate) },
  { label: "Order Time", key: "time", render: (row) => row.time || row.orderTime || "--------" },
  { label: "Order Id", key: "order_id", render: (row) => row.o_id || row.order_id || row.id || "--------" },
  { label: "Type", key: "type", render: (row) => row.type || row.order_type || row.orderType || "--------" },
  { label: "Table", key: "table", render: (row) => row.table_label || row.table || row.table_no || "--------" },
  { label: "Order Status", key: "order_status" },
  { label: "Payment Mode", key: "payment_mode" },
  { label: "Sub-Total(Rs.)", key: "amount", render: (row) => Number(row.amount || row.subTotal || 0).toFixed(2) },
  { label: "CGST(Rs.)", key: "cgst", render: (row) => Number(row.cgst || 0).toFixed(2) },
  { label: "SGST(Rs.)", key: "sgst", render: (row) => Number(row.sgst || 0).toFixed(2) },
  { label: "Discount(Rs.)", key: "discount", render: (row) => Number(row.discount || 0).toFixed(2) },
  { label: "Via Cash(Rs.)", key: "via_cash", render: (row) => Number(row.via_cash || row.viaCash || 0).toFixed(2) },
  { label: "Via Card(Rs.)", key: "via_card", render: (row) => Number(row.via_card || row.viaCard || 0).toFixed(2) },
  { label: "Via UPI(Rs.)", key: "via_upi", render: (row) => Number(row.via_upi || row.viaUpi || 0).toFixed(2) },
  { label: "Grand Total(Round)", key: "grand_total", render: (row) => Number(row.grand_total || row.grandTotal || 0).toFixed(2) },
];

const OrderReport = ({ rows = [], loading }) => {
  const tableRows = rows.map((row, index) => ({ ...row, serial: index + 1 }));

  const totals = useMemo(
    () =>
      rows.reduce(
        (acc, row) => ({
          subTotal: acc.subTotal + Number(row.amount || row.subTotal || 0),
          cgst: acc.cgst + Number(row.cgst || 0),
          sgst: acc.sgst + Number(row.sgst || 0),
          viaCash: acc.viaCash + Number(row.via_cash || row.viaCash || 0),
          viaCard: acc.viaCard + Number(row.via_card || row.viaCard || 0),
          viaUpi: acc.viaUpi + Number(row.via_upi || row.viaUpi || 0),
          grandTotal: acc.grandTotal + Number(row.grand_total || row.grandTotal || 0),
        }),
        defaultTotals,
      ),
    [rows],
  );

  return (
    <div className="order-report">
      <ReportDataTable
        columns={columns}
        rows={tableRows}
        loading={loading}
        emptyMessage="No order report data found."
      />

      <div className="order-report-total-line" />

      <div className="order-report-summary">
        <div>
          <span>Sub Total</span>
          <strong>{formatAmount(totals.subTotal)}</strong>
        </div>
        <div>
          <span>CGST</span>
          <strong>{formatAmount(totals.cgst)}</strong>
        </div>
        <div>
          <span>SGST</span>
          <strong>{formatAmount(totals.sgst)}</strong>
        </div>
        <div>
          <span>Via Cash</span>
          <strong>{formatAmount(totals.viaCash)}</strong>
        </div>
        <div>
          <span>Via Card</span>
          <strong>{formatAmount(totals.viaCard)}</strong>
        </div>
        <div>
          <span>Via UPI</span>
          <strong>{formatAmount(totals.viaUpi)}</strong>
        </div>
        <div>
          <span>Grand Total(Round)</span>
          <strong>{formatAmount(totals.grandTotal)}</strong>
        </div>
      </div>
    </div>
  );
};

export default OrderReport;
